export default __webpack_public_path__ + "static/media/arrow-right-disable.d7aa0445.svg";